import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';

export function SectionTab({ name, onClick, active, children, ...rest }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 4px',
        width: '100%',
        minHeight: 64,
        borderRadius: '4px',
        color: active ? '#0d83cd' : '#666',
        backgroundColor: active ? 'rgba(13,131,205,0.08)' : 'transparent',
        '&:hover': {
          backgroundColor: active
            ? 'rgba(13,131,205,0.12)'
            : 'rgba(0,0,0,0.04)',
        },
        transition: 'all 0.15s ease',
      }}
      {...rest}
    >
      <Box
        sx={{
          fontSize: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 0.5,
        }}
      >
        {children}
      </Box>
      <Typography
        variant="caption"
        sx={{
          fontSize: '10px',
          lineHeight: 1.2,
          textTransform: 'none',
          fontWeight: active ? 600 : 400,
        }}
      >
        {name}
      </Typography>
    </ButtonBase>
  );
}

export default SectionTab;
